import { RadioboxIndeterminateVariantIcon } from './RadioboxIndeterminateVariantIcon';

/**
 * author: Jeff Anders
 * id 36F9BAE6-DB6B-4CE5-B7CA-B777ABA8CB1B
 * name radiobox-indeterminate-variant
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radiobox-indeterminate-variant.svg
 * tags
 * - Form 
 */
export const RadioButtonIndeterminateIcon = RadioboxIndeterminateVariantIcon;
export default RadioButtonIndeterminateIcon